module.exports = __webpack_public_path__ + "static/Akash_Kathavate-d84b017a3abafc73a735eb5714aa31c6.jpeg";